import axios from 'axios';
import { API_BASE_URL } from '../../utils/constants';

export const handleFetchBlacklist = async () => {
  const response = await axios({
    method: 'get',
    baseURL: API_BASE_URL,
    url: '/getBlackList',
    params: {
      limit: 1,
      skip: 1,
    },
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const handleRemoveUserFromBlacklist = async ({ ip, removeAll }) => {
  const bodyData = {};
  if (ip !== null) bodyData.id = ip;
  if (removeAll !== null) bodyData.all = removeAll;
  const response = await axios({
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/removeFromBlackList',
    withCredentials: true,
    data: JSON.stringify(bodyData),
    headers: {
      'Content-Type': 'Application/json',
    },
  });
  return response.data.success;
};
